module.exports = __webpack_public_path__ + "resources/icon_28_applaud.4b2726e4961436f2.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_applaud.png
// module id = 420
// module chunks = 0 1 2 3 4